var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "master-detail-caption" }),
      _vm._v(" "),
      _c(
        "DxDataGrid",
        {
          attrs: {
            "data-source": _vm.dataSource,
            "show-borders": true,
            "column-auto-width": true,
          },
        },
        [
          _c("DxSorting", {
            attrs: {
              "ascending-text": "Ordem crescente",
              "descending-text": "Ordem descrescente",
              "clear-text": "Limpar ordenação",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: { caption: "Lote estocagem", "data-field": "LoteEstocagem" },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              caption: "Data da movimentação",
              "data-field": "DataMovimentacao",
              "data-type": "date",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              caption: "Data de vencimento",
              "data-field": "DataVencimento",
              "data-type": "date",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: { caption: "Quantidade", "data-field": "Quantidade" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }